
import React, {
  createContext,
  useState,
  useEffect,
  useContext,
} from "react";
import { getCourses, saveCourse, getCourseUsers, getContentStatuses } from "../services/courses";
import { AppContext } from "./AppContext";
import { useAuthContext } from "./AuthContext";

const CourseContext = createContext();

export const CourseProvider = ({ children }) => {
  const { activeUser } = useAuthContext();
  const { selectedClient } = useContext(AppContext);
  const [currentCourse, setCurrentCourse] = useState();
  const [courseUsers, setCourseUsers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState();
  const [updatedCourse, setUpdatedCourse] = useState();
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [contentStatuses, setContentStatuses] = useState([]);

  useEffect(() => {
    if (!activeUser || !selectedClient) {
      return;
    }

    const fetchCourses = async () => {
      setLoadingCourses(true);
      try {
        const response = await getCourses(selectedClient);
        if (response.success) {
          setCourses(response.courses);
        } else {
          setCourses([]);
        }
      }
      catch (error) {
        console.error("Error fetching courses: ", error);
      }
      finally {
        setLoadingCourses(false);
      }
    }

    fetchCourses();

  }, [activeUser, selectedClient]);

  useEffect(() => {
    if (!selectedCourse) {
      return;
    }
    const fetchCourseUsers = async () => {
      try {
        const response = await getCourseUsers(selectedCourse.public_id, selectedClient);
        if (response.success) {
          setCourseUsers(response.users);
        } else {
          setCourseUsers([]);
        }
      }
      catch (error) {
        console.error("Error fetching course users: ", error);
      }
    };

    fetchCourseUsers();

    const fetchContentStatuses = async () => {
      const results = await getContentStatuses(selectedCourse.public_id);
      console.log("!!! content status RESULTS: ", results);
      if (results.success) {
        setContentStatuses(results.statuses);
      } else {
        console.error("Failed to fetch content statuses:", results.message);
      }
    };

    fetchContentStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCourse]);

  const updateContentStatus = (status) => {
    const index = contentStatuses.findIndex((s) => s.public_id === status.public_id);
    if (index !== -1) {
      const newStatuses = [...contentStatuses];
      newStatuses[index].status = status.status;
      setContentStatuses(newStatuses);
    }
  }

  const updateContentStatuses = (courseId) => {
    const fetchContentStatuses = async () => {
      const results = await getContentStatuses(courseId);
      console.log("!!! content status RESULTS: ", results);
      if (results.success) {
        setContentStatuses(results.statuses);
      } else {
        console.error("Failed to fetch content statuses:", results.message);
      }
    };

    fetchContentStatuses();
  }


  const getCourse = (courseId) => {
    console.log("COURSES: ", courses);
    let course = null;
    courses.forEach((c) => {
      if (c.public_id === courseId) {
        course = c;
      }
    }
    );
    return course;
  }

  const canSaveCourse = () => {
    if (!updatedCourse) {
      return false;
    }
    if (!updatedCourse.name || updatedCourse.name.trim() === "") {
      return false;
    }
    return true;
  }

  const saveUpdatedCourse = async () => {
    console.log("!!! SAVE UPDATED data SET CALLED: ", updatedCourse);


    const results = await saveCourse(updatedCourse, selectedClient.id);
    if (results.success) {
      const course = results.course;
      setSelectedCourse(course);
      setUpdatedCourse(course);
      return course.public_id;
    }
  }

  return (
    <CourseContext.Provider
      value={{
        courses,
        setCourses,
        getCourse,
        currentCourse,
        setCurrentCourse,
        loadingCourses,
        updatedCourse,
        setUpdatedCourse,
        setSelectedCourse,
        selectedCourse,
        saveUpdatedCourse,
        canSaveCourse,
        courseUsers,
        setCourseUsers,
        contentStatuses,
        updateContentStatus,
        updateContentStatuses,
      }}
    >
      {children}
    </CourseContext.Provider>
  );
};

//export default CourseContext;

export const useCourseContext = () => {
  return useContext(CourseContext);
};
